import { Badge, IconButton } from "@bonusx-global/bx-design-system";
import { BellOutlined } from "@bonusx-global/bx-icons";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NOTIFICATIONS_PATH } from "../../../../../../constants/env";
import { useNotificationApi } from "../../../../../hooks/useNotificationApi";

function HeaderV2NotificationIcon(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: notifications } = useNotificationApi({ type: "citizen" });

  const notificationCount = useMemo(
    function memoizeNotificationCount() {
      return notifications?.count ?? 0;
    },
    [notifications]
  );

  const onClickIconCallback = useCallback(
    function onClickIcon() {
      navigate(NOTIFICATIONS_PATH, { state: { from: location.pathname } });
    },
    [location.pathname, navigate]
  );

  return (
    <IconButton color="primary" onClick={onClickIconCallback}>
      <Badge color="error" badgeContent={notificationCount}>
        <BellOutlined />
      </Badge>
    </IconButton>
  );
}

export default HeaderV2NotificationIcon;
